import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f42787c4")
const _hoisted_1 = { class: "ml-1" }
const _hoisted_2 = { class: "text-sm divide-y dark:divide-gray-900" }
const _hoisted_3 = { class: "px-3 pt-3 pb-1 bg-gray-50 dark:bg-gray-800 rounded-t" }
const _hoisted_4 = { class: "text-gray-500" }
const _hoisted_5 = { class: "text-lg" }
const _hoisted_6 = { class: "p-3" }
const _hoisted_7 = { class: "whitespace-nowrap flex items-center mb-1" }
const _hoisted_8 = { class: "ml-1 text-gray-500 text-xs" }
const _hoisted_9 = {
  key: 0,
  class: "whitespace-nowrap flex items-center mb-1"
}
const _hoisted_10 = { class: "ml-1 text-gray-500 text-xs" }
const _hoisted_11 = { class: "whitespace-nowrap flex items-center" }
const _hoisted_12 = { class: "ml-1 text-gray-500 text-xs flex items-center" }
const _hoisted_13 = {
  key: 1,
  class: "whitespace-nowrap flex flex-col mt-2 ml-px"
}
const _hoisted_14 = {
  key: 0,
  class: "init-vert-bar"
}
const _hoisted_15 = {
  key: 1,
  class: "vert-bar"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "horiz-bar" }, null, -1)
const _hoisted_17 = { class: "text-gray-500 text-xs ml-2" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarsIcon = _resolveComponent("StarsIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!

  return (_ctx.pool.hasLiquidityMiningRewards)
    ? (_openBlock(), _createBlock(_component_BalTooltip, {
        key: 0,
        noPad: ""
      }, {
        activator: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.pool.hasLiquidityMiningRewards)
              ? (_openBlock(), _createBlock(_component_StarsIcon, _mergeProps({
                  key: 0,
                  class: "h-5 text-yellow-300"
                }, _ctx.$attrs), null, 16))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('totalAPR')), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.fNum(_ctx.pool.dynamic.apr.total, 'percent')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.fNum(_ctx.pool.dynamic.apr.pool, 'percent')) + " ", 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('swapFeeAPR')), 1)
              ]),
              (_ctx.hasThirdPartyAPR)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.fNum(_ctx.pool.dynamic.apr.thirdParty, 'percent')) + " ", 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.thirdPartyAPRLabel), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.fNum(_ctx.pool.dynamic.apr.liquidityMining, 'percent')) + " ", 1),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('liquidityMiningAPR')) + " ", 1),
                  _createVNode(_component_StarsIcon, { class: "h-4 text-yellow-300" })
                ])
              ]),
              (_ctx.multiRewardPool)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lmBreakdown, (apr, address, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: address,
                        class: "flex items-center"
                      }, [
                        (index === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15)),
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.fNum(apr, 'percent')) + " ", 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.lmTokens[address].symbol) + " " + _toDisplayString(_ctx.$t('apr')), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}